export default __webpack_public_path__ + "static/media/90s_background.2e72d75f.mp3";